export const WORLD_PICKLEBALL_RANKINGS = 'World Pickleball Rankings';

// `shortLabel` is what the mobile pills render — the full label wraps onto two rows
// on a phone, which made the two buttons different heights (PW-7597).
export const RANKINGS_TYPE_OPTIONS = [
  { label: WORLD_PICKLEBALL_RANKINGS, shortLabel: 'WPR', value: 'proWorldRanking' },
  { label: 'Current Seed', shortLabel: 'Current Seed', value: 'currentSeed' },
] as const;

export const PRO_WORLD_RANKING_TABS = [
  { label: 'Women\u2019s', type: '8', gender: 'F' },
  { label: 'Men\u2019s', type: '8', gender: 'M' },
] as const;

export const CURRENT_SEED_TABS = [
  {
    label: `Women's Singles`,
    testId: 'rankings-button-woman-singles',
    type: '1',
    gender: 'F',
  },
  {
    label: `Women's Doubles`,
    testId: 'rankings-button-woman-doubles',
    type: '4',
    gender: 'F',
  },
  {
    label: `Women's Mixed Doubles`,
    testId: 'rankings-button-woman-mixed',
    type: '3',
    gender: 'F',
  },
  { label: `Men's Singles`, testId: 'rankings-button-man-singles', type: '2', gender: 'M' },
  { label: `Men's Doubles`, testId: 'rankings-button-man-doubles', type: '5', gender: 'M' },
  {
    label: `Men's Mixed Doubles`,
    testId: 'rankings-button-man-mixed',
    type: '3',
    gender: 'M',
  },
] as const;

export type RankingsDropdownType = '' | 'rankBy' | 'country' | 'state' | 'week';
